module.exports = tribe.events.icons;